import { IScenePayload } from 'src/applications/Embed/types/IScene'
import { MatchingScene as MatchingV3 } from 'src/applications/Oversight/scenes/MatchingV3/index'

export const MatchingScene = ({
  batch,
  onComplete,
  workbookStatus,
  workspaceId
}: IScenePayload) => {
  return (
    <MatchingV3
      batchId={batch.batchId}
      onWorkbookComplete={(workbookId) => onComplete({ workbookId })}
      embeds={true}
      workbookId={batch.workbookId}
      workbookStatus={workbookStatus}
      workspaceId={workspaceId}
    />
  )
}
